<div class="row">
    <div class="col-12 text-center">
        <p-selectButton [options]="stateOptions" [(ngModel)]="value" optionLabel="label" optionValue="value"
            (ngModelChange)="changeVisual()" />
    </div>
</div>
<ng-container *ngIf="value === 'men'">
    <div class="row text-center">
        <h4>
            {{month[getFecha().mes].nameES}} {{getFecha().anio}}
        </h4>
    </div>
    <div class="row">
        <div class="col-4 text-start"><i class="pi pi-angle-double-left shadow-2" (click)="changeDate(-1)"></i></div>
        <div class="col-4 text-center"><button class="btn btn-secondary" (click)="restoreDate()">Hoy</button></div>
        <div class="col-4 text-end"><i class="pi pi-angle-double-right shadow-2" (click)="changeDate(1)"></i></div>
    </div>

    <table>
        <tr>
            <th colspan="1">Domingo</th>
            <th colspan="1">Lunes</th>
            <th colspan="1">Martes</th>
            <th colspan="1">Miércoles</th>
            <th colspan="1">Jueves</th>
            <th colspan="1">Viernes</th>
            <th colspan="1">Sábado</th>
        </tr>
        <ng-container *ngFor="let c of calendario; let i = index">
            <tr *ngIf="c.diaSemana === 6; else a">
                <ng-container *ngFor="let j of dias">
                    <td class="relative" *ngIf="calendario[i - j]; else c">
                        <app-item-agenda-min class="" [day]="returnDate(calendario[i - j].fecha)"
                            [eventos]="calendario[i - j].eventos!" (sendEvento)="eventoClick($event)" />
                    </td>
                    <ng-template #c>
                        <td></td>
                    </ng-template>
                </ng-container>
                <td><app-item-agenda-min class="" [day]="returnDate(calendario[i].fecha)"
                        [eventos]="calendario[i].eventos!" (sendEvento)="eventoClick($event)" /></td>
            </tr>
            <ng-template #a>
                <ng-container *ngIf="i === calendario.length - 1">
                    <tr>
                        <ng-container *ngFor="let cR of retornarFaltante(calendario[i].diaSemana+1)">
                            <td>
                                <app-item-agenda-min class="" [day]="returnDate(cR.fecha)" [eventos]="cR.eventos!"
                                    (sendEvento)="eventoClick($event)" />
                            </td>
                        </ng-container>
                    </tr>
                </ng-container>
            </ng-template>

        </ng-container>
    </table>
</ng-container>

<!-- Calendario semanal -->
<ng-container *ngIf="value === 'sem' && calendarioSemana[0]">
    <div class="row text-center">
        <h4>
            {{calendarioSemana[0].fecha | date: 'dd/MM/yy'}} --
            {{calendarioSemana[calendarioSemana.length - 1].fecha | date: 'dd/MM/yy'}}
        </h4>
    </div>
    <div class="row">
        <div class="col-4 text-start"><i class="pi pi-angle-double-left shadow-2" (click)="changeDateSemana(-7)"></i>
        </div>
        <div class="col-4 text-center"><button class="btn btn-secondary" (click)="restoreDateSemana()">Hoy</button>
        </div>
        <div class="col-4 text-end"><i class="pi pi-angle-double-right shadow-2" (click)="changeDateSemana(7)"></i>
        </div>
    </div>

    <table>
        <tr class="semana">
            <!-- Cabecera vacía, para "todo el día" -->
            <th></th>
            <th *ngFor="let c of calendarioSemana">
                {{retornarDia(c.diaSemana)}} {{ c.fecha | date: 'dd/MM' }}
            </th>
        </tr>
        <ng-container *ngFor="let h of horas; index as i">
            <tr class="semana">
                <ng-container *ngIf="h === 0; else showIndex">
                    <!-- Todo el día -->
                    <td>
                        <p style="width: 150px;">Todo el día</p>
                    </td>
                </ng-container>
                <ng-template #showIndex>
                    <!-- Mostramos la hora -->
                    <td>
                        <p style="width: 150px;">{{h - 1}} horas</p>
                    </td>
                </ng-template>
                <ng-container *ngFor="let c of calendarioSemana">
                    <!-- Aca van los eventos, con position absolute, top 0 y height dependiendo de las horas -->
                    <ng-container *ngIf="i === 0;">
                        <td rowspan="25" style="padding: 0;">
                            <div style="position: relative; width: 150px; height: 100%">
                                <!-- Aquí los eventos que son de todo el día -->
                                <div style="width: 100%; position: absolute; overflow: auto;" [style.height.px]="60"
                                    [style.top.px]="0">
                                    <ng-container *ngFor="let ev of c.eventos">
                                        <div *ngIf="ev.link || !ev.fin" style="width: 100%; white-space: nowrap;"
                                            [style.background]="ev.color">
                                            <p (click)="eventoClick(ev)" class="item-text"><small>{{ev.titulo}}</small>
                                            </p>
                                        </div>
                                    </ng-container>
                                </div>
                                <!-- Aquí los eventos que tienen un horario definido -->
                                <ng-container *ngFor="let ev of c.eventos">
                                    <ng-container *ngIf="!ev.link && ev.fin;">
                                        <div style="width: 100%; position: absolute; white-space: nowrap;"
                                            (click)="eventoClick(ev)" [style.height.px]="calcularHeight(ev)"
                                            [style.background]="ev.color" [style.top.px]="calcularPosition(ev)">
                                            <p class="item-text" style="color:white"><small>{{ev.titulo}}</small></p>
                                        </div>
                                    </ng-container>
                                </ng-container>

                            </div>
                        </td>
                    </ng-container>
                </ng-container>
            </tr>
        </ng-container>

    </table>
</ng-container>

<p-dialog [header]="evento ? evento.titulo : ''" [modal]="true" [draggable]="false" [(visible)]="visible">
    <ng-container *ngIf="evento?.id_reg; else eventoOnly">
        <div class="gap-3 mb-3">
            <label for="username" class="font-semibold">Hallazgo</label>
            <textarea pInputTextarea id="username" class="flex-auto" autocomplete="off" [style]="{'width': '100%'}"
                readonly [value]="evento?.hallazgo"></textarea>
        </div>
        <div class="gap-3 mb-3">
            <label for="username" class="font-semibold">Acción recomendada</label>
            <textarea pInputTextarea id="username" class="flex-auto" autocomplete="off" [style]="{'width': '100%'}"
                readonly [value]="evento?.accion!"></textarea>
        </div>
        <div class="gap-3 mb-3">
            <label for="username" class="font-semibold">Vencimiento</label>
            <input pInputTextarea id="username" readonly class="flex-auto" autocomplete="off"
                [style]="{'width': '100%'}" [value]="evento?.inicio! | date: 'dd/MM/yyyy'" />
        </div>
        <p *ngIf="isVencida(evento?.inicio)"
            style="width: 100%; padding: 10px; border-radius: 10px; color: white; background: #ff5252; text-align: center;">
            ¡Este evento ya venció!</p>
        <div class="flex justify-content-end gap-2">
            <p-button label="Ver registro" [routerLink]="'/' + evento?.link!" />
            <p-button label="Cerrar" severity="secondary" (click)="visible = false" />
        </div>
    </ng-container>
    <ng-template #eventoOnly>
        <div class="gap-3 mb-3">
            <label for="username" class="font-semibold">Inicio</label>
            <input pInputTextarea id="username" readonly class="flex-auto" autocomplete="off"
                [style]="{'width': '100%'}" [value]="evento?.inicio! | date: 'dd/MM/yyyy'" />
        </div>
        <div class="flex justify-content-end gap-2">
            <p-button
                *ngIf="(evento?.id_usuario! ? user ? user.id === evento?.id_usuario!.id : false : false) || (user ? user.superuser : false)"
                label="Eliminar evento" (click)="delete(evento?.id!)" />
            <p-button label="Cerrar" severity="secondary" (click)="visible = false" />
        </div>
    </ng-template>

</p-dialog>

<app-dialog #dialog />